import clsx from 'clsx';
import React from 'react';

export function SubmitIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      className={clsx('w-[24px] h-[24px] shrink-0 flex-none', className)}
      aria-hidden="true"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73432 2.5984C2.92771 2.40193 3.2133 2.3274 3.47804 2.4043C10.1767 4.35021 16.3974 7.41817 21.9233 11.3908C22.1193 11.5317 22.2355 11.7583 22.2355 11.9998C22.2355 12.2412 22.1193 12.4678 21.9233 12.6087C16.3974 16.5814 10.1767 19.6494 3.47814 21.5954C3.2134 21.6723 2.92781 21.5978 2.73441 21.4013C2.54102 21.2049 2.471 20.9181 2.55207 20.6546L5.21504 12L2.55198 3.3451C2.47091 3.0816 2.54093 2.79487 2.73432 2.5984ZM6.55367 12.75L4.40041 19.7481C10.0795 17.9504 15.3886 15.32 20.1845 11.9998C15.3886 8.67962 10.0794 6.04922 4.40031 4.25162L6.55367 11.25L13.5 11.25C13.9142 11.25 14.25 11.5858 14.25 12C14.25 12.4142 13.9142 12.75 13.5 12.75L6.55367 12.75Z"
        fill="white"
      />
    </svg>
  );
}
